import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "./StudyDashboard.css";
import "../../overall.css";

function StudyDashboardSkeleton() {
  return (
    <div className="parentContainer study-dashboard">
      <div className="mainContainer">
        {/* TitleBar Skeleton */}
        <div style={{ marginBottom: "24px" }}>
          <Skeleton height={40} width={250} style={{ marginBottom: "8px" }} />
        </div>

        {/* Dropdown Skeleton */}
        <div style={{ marginBottom: "24px" }}>
          <Skeleton height={48} width={300} />
        </div>

        {/* Study Information Cards Grid */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "16px", marginBottom: "24px" }}>
          <div>
            <Skeleton height={200} />
          </div>
          <div>
            <Skeleton height={200} />
          </div>
        </div>

        {/* Graph Component Skeleton */}
        <div style={{ marginTop: "32px" }}>
          <Skeleton height={400} />
        </div>

        {/* Additional Cards */}
        <div style={{ marginTop: "24px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
          <Skeleton height={150} />
          <Skeleton height={150} />
        </div>
      </div>
    </div>
  );
}

export default StudyDashboardSkeleton;
